"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsetSessionData = exports.unsetLoadingState = exports.unsetCurrentActivity = exports.unsetActivityApplicable = exports.unsetActiveSession = exports.setSessionHeldMetrics = exports.setSessionData = exports.setSessionComplete = exports.setSessionCalendarMetrics = exports.setLoadingState = exports.setFilledSession = exports.setCurrentActivityUserLists = exports.setCurrentActivity = exports.setActivityComplete = exports.setActivityApplicable = exports.setActiveSession = exports.resetState = exports.markSessionComplete = exports.markActivityComplete = exports.initialState = exports.determineInitialSession = exports.determineInitialActivity = exports["default"] = exports.changeCurrentActivity = exports.changeActivityApplicable = exports.changeActiveSession = exports.callPostSessionRouteUnload = exports.callPostSessionRoute = exports.callPostFlowHook = exports.buildState = void 0;
var _reduxActions = require("redux-actions");
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _maxBy2 = _interopRequireDefault(require("lodash/maxBy"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _first2 = _interopRequireDefault(require("lodash/first"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isNull2 = _interopRequireDefault(require("lodash/isNull"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdApollo = require("cccisd-apollo");
var _moment = _interopRequireDefault(require("moment"));
var _fixedSession = require("../selectors/fixedSession.js");
var _sendBeacon = _interopRequireDefault(require("../helpers/sendBeacon.js"));
var _allChildrenComplete = _interopRequireDefault(require("../helpers/allChildrenComplete"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _handleActions;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } // import _isEmpty from 'lodash/isEmpty';
var Appdefs = window.cccisd.appDefs;
var Boilerplate = window.cccisd.boilerplate;
// Initial state
var initialState = exports.initialState = {
  loading: true,
  sessions: [],
  activeSessionId: 0,
  currentActivityHandle: ''
};

// Actions
var SET_LOADING_STATE = 'fixedSession/SET_LOADING_STATE';
var UNSET_LOADING_STATE = 'fixedSession/UNSET_LOADING_STATE';
var SET_SESSION_DATA = 'fixedSession/SET_SESSION_DATA';
var UNSET_SESSION_DATA = 'fixedSession/UNSET_SESSION_DATA';
var SET_ACTIVE_SESSION = 'fixedSession/SET_ACTIVE_SESSION';
var SET_FILLED_SESSION = 'fixedSession/SET_FILLED_SESSION';
var UNSET_ACTIVE_SESSION = 'fixedSession/UNSET_ACTIVE_SESSION';
var SET_CURRENT_ACTIVITY = 'fixedSession/SET_CURRENT_ACTIVITY';
var UNSET_CURRENT_ACTIVITY = 'fixedSession/UNSET_CURRENT_ACTIVITY';
var SET_ACTIVITY_APPLICABLE = 'fixedSession/SET_ACTIVITY_APPLICABLE';
var UNSET_ACTIVITY_APPLICABLE = 'fixedSession/UNSET_ACTIVITY_APPLICABLE';
var RESET_STATE = 'fixedSession/RESET_STATE';
var SET_ACTIVITY_COMPLETE = 'fixedSession/SET_ACTIVITY_COMPLETE';
var SET_SESSION_COMPLETE = 'fixedSession/SET_SESSION_COMPLETE';
var SET_SESSION_HELD_METRICS = 'fixedSession/SET_SESSION_HELD_METRICS';
var SET_CURRENT_ACTIVITY_USER_LISTS = 'fixedSession/SET_CURRENT_ACTIVITY_USER_LISTS';

// Action Creators
var setLoadingState = exports.setLoadingState = (0, _reduxActions.createAction)(SET_LOADING_STATE);
var unsetLoadingState = exports.unsetLoadingState = (0, _reduxActions.createAction)(UNSET_LOADING_STATE);
var setSessionData = exports.setSessionData = (0, _reduxActions.createAction)(SET_SESSION_DATA);
var unsetSessionData = exports.unsetSessionData = (0, _reduxActions.createAction)(UNSET_SESSION_DATA);
var setActiveSession = exports.setActiveSession = (0, _reduxActions.createAction)(SET_ACTIVE_SESSION);
var unsetActiveSession = exports.unsetActiveSession = (0, _reduxActions.createAction)(UNSET_ACTIVE_SESSION);
var setCurrentActivity = exports.setCurrentActivity = (0, _reduxActions.createAction)(SET_CURRENT_ACTIVITY);
var unsetCurrentActivity = exports.unsetCurrentActivity = (0, _reduxActions.createAction)(UNSET_CURRENT_ACTIVITY);
var setActivityApplicable = exports.setActivityApplicable = (0, _reduxActions.createAction)(SET_ACTIVITY_APPLICABLE);
var unsetActivityApplicable = exports.unsetActivityApplicable = (0, _reduxActions.createAction)(UNSET_ACTIVITY_APPLICABLE);
var resetState = exports.resetState = (0, _reduxActions.createAction)(RESET_STATE);
var setActivityComplete = exports.setActivityComplete = (0, _reduxActions.createAction)(SET_ACTIVITY_COMPLETE);
var setSessionComplete = exports.setSessionComplete = (0, _reduxActions.createAction)(SET_SESSION_COMPLETE);
var setSessionHeldMetrics = exports.setSessionHeldMetrics = (0, _reduxActions.createAction)(SET_SESSION_HELD_METRICS);
var setFilledSession = exports.setFilledSession = (0, _reduxActions.createAction)(SET_FILLED_SESSION);
var setCurrentActivityUserLists = exports.setCurrentActivityUserLists = (0, _reduxActions.createAction)(SET_CURRENT_ACTIVITY_USER_LISTS);

/* ***************************************************** */
/* ********************** ACTIONS ********************** */
/* ***************************************************** */

var buildState = exports.buildState = function buildState(queries, sessionData, pawn, policy) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      var sessions, activeSessionResponseSet, filledActiveSession, currentActivity, currentActivityObj, formattedUserLists;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // set loading
            dispatch(setLoadingState());

            // load sessions and determine active session
            _context.n = 1;
            return getSessions(queries.getSessions, pawn, sessionData);
          case 1:
            sessions = _context.v;
            dispatch(setSessionData(sessions));
            activeSessionResponseSet = determineInitialSession(policy, sessions);
            dispatch(setActiveSession(activeSessionResponseSet));
            _context.n = 2;
            return _fillActiveSession({
              activeSession: (0, _fixedSession.getActiveSession)(getState().appdefs.fixedSession),
              queries: queries,
              pawn: pawn
            });
          case 2:
            filledActiveSession = _context.v;
            dispatch(setFilledSession(filledActiveSession));

            // determine current activity
            currentActivity = _getCurrent(policy, filledActiveSession.activities);
            dispatch(setCurrentActivity(currentActivity));
            currentActivityObj = (0, _fixedSession.getCurrentActivity)(getState().appdefs.fixedSession);
            if (!(currentActivityObj.acrossChildren && currentActivityObj.acrossChildrenSettings.flowUserLists)) {
              _context.n = 4;
              break;
            }
            _context.n = 3;
            return buildUserLists(currentActivityObj, pawn, currentActivityObj.acrossChildrenSettings.childrenQuery, filledActiveSession.responseSet);
          case 3:
            formattedUserLists = _context.v;
            dispatch(setCurrentActivityUserLists(formattedUserLists));
          case 4:
            dispatch(unsetLoadingState());
          case 5:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var callPostFlowHook = exports.callPostFlowHook = function callPostFlowHook(handle, data) {
  return function (dispatch, getState) {
    var appdefActivity = (0, _find2["default"])(Appdefs.sessions.fixedSettings.activities, function (activity) {
      return activity.handle === handle;
    });
    if (appdefActivity && 'postFlowRoute' in appdefActivity) {
      _cccisdAxios["default"].post(Boilerplate.route(appdefActivity.postFlowRoute), data);
    }
  };
};
var callPostSessionRouteUnload = exports.callPostSessionRouteUnload = function callPostSessionRouteUnload(data) {
  return function (dispatch, getState) {
    var activeSession = (0, _fixedSession.getActiveSession)(getState().appdefs.fixedSession);
    if ('postSessionRoute' in activeSession) {
      (0, _sendBeacon["default"])(Boilerplate.route(activeSession.postSessionRoute), data);
    }
  };
};
var callPostSessionRoute = exports.callPostSessionRoute = function callPostSessionRoute(data) {
  return function (dispatch, getState) {
    var activeSession = (0, _fixedSession.getActiveSession)(getState().appdefs.fixedSession);
    if ('postSessionRoute' in activeSession) {
      _cccisdAxios["default"].post(Boilerplate.route(activeSession.postSessionRoute), data);
    }
  };
};
var changeActiveSession = exports.changeActiveSession = function changeActiveSession(session, queries, pawn, policy) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch, getState) {
      var sessionData, filledActiveSession, currentActivity, currentActivityObj, formattedUserLists;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            dispatch(setLoadingState());
            // let newSession = _cloneDeep(session);
            dispatch(setActiveSession(session.responseSet));
            sessionData = getState().appdefs.fixedSession;
            _context2.n = 1;
            return _fillActiveSession({
              activeSession: session,
              queries: queries,
              pawn: pawn,
              sessionData: sessionData
            });
          case 1:
            filledActiveSession = _context2.v;
            dispatch(setFilledSession(filledActiveSession));

            // build out flow lists
            // buildUserLists(filledActiveSession, pawn);

            // determine current activity
            currentActivity = _getCurrent(policy, filledActiveSession.activities);
            dispatch(setCurrentActivity(currentActivity));
            currentActivityObj = (0, _fixedSession.getCurrentActivity)(getState().appdefs.fixedSession);
            if (!(currentActivityObj.acrossChildren && currentActivityObj.acrossChildrenSettings.flowUserLists)) {
              _context2.n = 3;
              break;
            }
            _context2.n = 2;
            return buildUserLists(currentActivityObj, pawn, currentActivityObj.acrossChildrenSettings.childrenQuery, filledActiveSession.responseSet);
          case 2:
            formattedUserLists = _context2.v;
            dispatch(setCurrentActivityUserLists(formattedUserLists));
          case 3:
            dispatch(unsetLoadingState());
          case 4:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var determineInitialActivity = exports.determineInitialActivity = function determineInitialActivity(activeSession, policy) {
  return function (dispatch, getState) {
    var currentActivity = {};
    currentActivity = _getCurrent(policy, activeSession.activities);
    dispatch(setCurrentActivity(currentActivity.handle));
  };
};
var setSessionCalendarMetrics = exports.setSessionCalendarMetrics = function setSessionCalendarMetrics(metricsObj, pawn, policy) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, getState) {
      var session, held, date, formattedDate;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            session = metricsObj.session, held = metricsObj.held, date = metricsObj.date;
            dispatch(setLoadingState());
            formattedDate = (0, _moment["default"])(date).format('MM/DD/YYYY');
            _context3.n = 1;
            return _cccisdAxios["default"].post(Boilerplate.route('metrics.api.v1.data.bulkUpdate'), {
              sourceHandle: 'impact',
              responseSet: session.responseSet,
              pawnId: pawn.pawn.pawnId,
              pawnHash: pawn.pawn.pawnHash,
              values: JSON.stringify(_defineProperty(_defineProperty({}, "".concat(session.sessionMetricsPrefix, "_held"), held ? 1 : 0), "".concat(session.sessionMetricsPrefix, "_date"), formattedDate))
            });
          case 1:
            _context3.n = 2;
            return _cccisdAxios["default"].post(Boilerplate.route('api.impact.set.current.session', {
              pawnId: pawn.pawn.pawnId
            }), {
              sessionMetricTag: "".concat(session.sessionDevTagPrefix, "Date"),
              session: session
            });
          case 2:
            dispatch(setSessionHeldMetrics({
              responseSet: session.responseSet,
              metrics: metricsObj
            }));
            dispatch(unsetLoadingState());
          case 3:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var markSessionComplete = exports.markSessionComplete = function markSessionComplete(session, pawn, policy) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            dispatch(setLoadingState());
            dispatch(setSessionComplete(session.handle));
            _context4.n = 1;
            return _cccisdAxios["default"].post(Boilerplate.route('metrics.api.v1.data.bulkUpdate'), {
              sourceHandle: 'impact',
              responseSet: session.responseSet,
              pawnId: pawn.pawn.pawnId,
              pawnHash: pawn.pawn.pawnHash,
              values: JSON.stringify(_defineProperty({}, "".concat(session.sessionMetricsPrefix, "_completed"), 1))
            });
          case 1:
            dispatch(unsetLoadingState());
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var markActivityComplete = exports.markActivityComplete = function markActivityComplete(handle) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch, getState) {
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            dispatch(setLoadingState());
            dispatch(setActivityComplete(handle));
            dispatch(unsetLoadingState());
          case 1:
            return _context5.a(2);
        }
      }, _callee5);
    }));
    return function (_x9, _x0) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var changeCurrentActivity = exports.changeCurrentActivity = function changeCurrentActivity(activity, pawn) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(dispatch, getState) {
      var currentActivityObj, formattedUserLists;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            dispatch(setCurrentActivity(activity.handle));
            currentActivityObj = (0, _fixedSession.getCurrentActivity)(getState().appdefs.fixedSession);
            if (!(currentActivityObj.acrossChildren && currentActivityObj.acrossChildrenSettings.flowUserLists)) {
              _context6.n = 2;
              break;
            }
            _context6.n = 1;
            return buildUserLists(currentActivityObj, {
              pawn: pawn
            }, currentActivityObj.acrossChildrenSettings.childrenQuery, (0, _fixedSession.getActiveSession)(getState().appdefs.fixedSession).responseSet);
          case 1:
            formattedUserLists = _context6.v;
            dispatch(setCurrentActivityUserLists(formattedUserLists));
          case 2:
            return _context6.a(2);
        }
      }, _callee6);
    }));
    return function (_x1, _x10) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var changeActivityApplicable = exports.changeActivityApplicable = function changeActivityApplicable(activity, applicable, pawn) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(dispatch, getState) {
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            _context7.n = 1;
            return _cccisdAxios["default"].post(Boilerplate.route('metrics.api.v1.data.bulkUpdate'), {
              sourceHandle: 'impact',
              responseSet: (0, _fixedSession.getActiveSession)(getState().appdefs.fixedSession).responseSet,
              pawnId: pawn.pawn.pawnId,
              pawnHash: pawn.pawn.pawnHash,
              values: JSON.stringify(_defineProperty({}, activity.applicableMetricsHandle, applicable ? 1 : 0))
            });
          case 1:
            if (applicable) {
              dispatch(setActivityApplicable(activity.handle));
            } else {
              dispatch(unsetActivityApplicable(activity.handle));
            }
          case 2:
            return _context7.a(2);
        }
      }, _callee7);
    }));
    return function (_x11, _x12) {
      return _ref7.apply(this, arguments);
    };
  }();
};

/* ***************************************************** */
/* ********************** HELPERS ********************** */
/* ***************************************************** */

var _getActiveSession = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(pawn, query, responseSet) {
    var variables, thaquery, result;
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          variables = {
            responseSet: responseSet,
            pawnId: pawn.pawn.pawn.pawnId
          };
          thaquery = (0, _cccisdApollo.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        ", "\n    "])), query);
          _context8.n = 1;
          return _cccisdApollo.client.query({
            query: thaquery,
            variables: variables,
            fetchPolicy: 'network-only'
          });
        case 1:
          result = _context8.v;
          return _context8.a(2, result.data);
      }
    }, _callee8);
  }));
  return function _getActiveSession(_x13, _x14, _x15) {
    return _ref8.apply(this, arguments);
  };
}();
var determineInitialSession = exports.determineInitialSession = function determineInitialSession(policy, sessions) {
  var current = {};
  if (policy === 'last_incomplete') {
    var maxItem = (0, _maxBy2["default"])((0, _filter2["default"])(sessions, function (a) {
      return a.complete === true;
    }), function (o) {
      return o.responseSet;
    });
    if (maxItem === sessions[sessions.length]) {
      current = (0, _maxBy2["default"])((0, _filter2["default"])(sessions, function (a) {
        return a.complete === true;
      }), function (o) {
        return o.responseSet;
      });
    } else {
      // set to last completed session + 1
      current = sessions[(0, _findIndex2["default"])(sessions, maxItem) + 1].responseSet;
    }
  } else if (policy === 'first_incomplete') {
    // find first session where:
    // -> session is not complete AND there is no date (first session not interacted) OR
    // -> session is not complete AND the is a date AND session is held (first session interacted with that is held but not complete)
    var firstFalse = (0, _find2["default"])(sessions, function (s) {
      return s.complete === false && !s.date || s.complete === false && s.date && s.held;
    });
    if (firstFalse) {
      current = firstFalse.responseSet;
    } else {
      current = (0, _last2["default"])(sessions).responseSet;
    }
  }
  return current;
};
var _getCurrent = function _getCurrent(policy, array) {
  var current = {};
  if (policy === 'last_incomplete') {
    var maxItem = (0, _maxBy2["default"])((0, _filter2["default"])(array, function (a) {
      return a.complete === true;
    }), function (o) {
      return o.responseSet;
    });
    if (maxItem === array[array.length]) {
      current = (0, _maxBy2["default"])((0, _filter2["default"])(array, function (a) {
        return a.complete === true;
      }), function (o) {
        return o.responseSet;
      });
    } else {
      // set to last completed session + 1
      current = array[(0, _findIndex2["default"])(array, maxItem) + 1].handle;
    }
  } else if (policy === 'first_incomplete') {
    var activityProgress = (0, _find2["default"])(array, function (a) {
      return a.progress.completed === false;
    });
    if (activityProgress) {
      current = activityProgress.handle;
    } else {
      current = (0, _first2["default"])(array).handle;
    }
  }
  return current;
};
var getSessions = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(query, pawn, sessionData) {
    var variables, sortedSessions, thaquery, sessionsResponse;
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          variables = {
            pawnId: pawn.pawn.pawn.pawnId
          }; // sort fields
          sortedSessions = (0, _sortBy2["default"])(sessionData, [function (f) {
            return f.order;
          }]); // get session metrics for all response sets
          thaquery = (0, _cccisdApollo.gql)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", "\n    "])), query);
          _context9.n = 1;
          return _cccisdApollo.client.query({
            query: thaquery,
            variables: variables,
            fetchPolicy: 'network-only'
          });
        case 1:
          sessionsResponse = _context9.v;
          // set up sessionData
          sortedSessions.forEach(function (session) {
            // get data for each appdef session
            var metricsForReponseSet = (0, _find2["default"])(sessionsResponse.data.roles["".concat(pawn.role, "List")][0].metricsList, function (metric) {
              return metric.responseSet === session.responseSet;
            });
            var variableData = [];
            // Get query stuff then make query
            session.activities.forEach(function (activity) {
              var hasFlowVarData = !(0, _isNil2["default"])(activity.flowVarData);
              var queryData;
              var dataPath;
              if (hasFlowVarData) {
                var queryString = activity.flowVarData.query;
                dataPath = activity.flowVarData.dataPath;
                queryData = getVariableData(queryString, variables);
                variableData.push({
                  dataPath: dataPath,
                  queryData: queryData,
                  namePath: activity.flowVarData.namePath,
                  varHandle: activity.varHandle,
                  varProcessor: activity.flowVarProcessor
                });
              }
            });
            var formattedData = formatFlowVardata(session, variableData);
            session.varData = formattedData;

            // set held, date,

            if (metricsForReponseSet) {
              if (!(0, _isNull2["default"])(metricsForReponseSet.devTags["".concat(session.sessionDevTagPrefix, "Held")])) {
                session.held = parseInt(metricsForReponseSet.devTags["".concat(session.sessionDevTagPrefix, "Held")], 10) === 1 ? true : false;
              } else {
                session.held = false;
              }
              if (!(0, _isNull2["default"])(metricsForReponseSet.devTags["".concat(session.sessionDevTagPrefix, "Date")])) {
                session.date = metricsForReponseSet.devTags["".concat(session.sessionDevTagPrefix, "Date")];
              } else {
                session.date = null;
              }
              if (!(0, _isNull2["default"])(metricsForReponseSet.devTags["".concat(session.sessionDevTagPrefix, "Completed")])) {
                session.complete = parseInt(metricsForReponseSet.devTags["".concat(session.sessionDevTagPrefix, "Completed")], 10) === 1 ? true : false;
              } else {
                session.complete = false;
              }
            } else {
              session.held = false;
              session.date = null;
              session.complete = false;
            }
          });

          // build flows with progress
          return _context9.a(2, sortedSessions);
      }
    }, _callee9);
  }));
  return function getSessions(_x16, _x17, _x18) {
    return _ref9.apply(this, arguments);
  };
}();
var formatFlowVardata = function formatFlowVardata(session, data) {
  if (!(0, _isEmpty2["default"])(data)) {
    var response = {};
    data.forEach(function (item) {
      var formattedData = determineProcessor(item);
      formattedData.then(function (result) {
        response[result.handle] = result.data;
      });
    });
    return response;
  }
};
var determineProcessor = /*#__PURE__*/function () {
  var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(obj) {
    var result;
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          return _context0.a(2, result);
      }
    }, _callee0);
  }));
  return function determineProcessor(_x19) {
    return _ref0.apply(this, arguments);
  };
}();

// USE FOR Flow Var Query
var getVariableData = /*#__PURE__*/function () {
  var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(queryString, variables) {
    var query, result;
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          query = (0, _cccisdApollo.gql)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        ", "\n    "])), queryString);
          _context1.n = 1;
          return _cccisdApollo.client.query({
            query: query,
            variables: variables,
            fetchPolicy: 'network-only'
          });
        case 1:
          result = _context1.v;
          return _context1.a(2, result);
      }
    }, _callee1);
  }));
  return function getVariableData(_x20, _x21) {
    return _ref1.apply(this, arguments);
  };
}();
var buildUserLists = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(activity, pawn, query, responseSet) {
    var variables, thaquery, result, userListsObj;
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.n) {
        case 0:
          // run query for children
          variables = {
            parentId: pawn.pawn.pawn.pawnId,
            handle: activity.flowHandle,
            responseSet: responseSet
          };
          thaquery = (0, _cccisdApollo.gql)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        ", "\n    "])), query);
          _context10.n = 1;
          return _cccisdApollo.client.query({
            query: thaquery,
            variables: variables,
            fetchPolicy: 'network-only'
          });
        case 1:
          result = _context10.v;
          userListsObj = {};
          activity.acrossChildrenSettings.flowUserLists.forEach(function (userList) {
            var children = (0, _get2["default"])(result.data, userList.childrenPath);
            var processedUserList = [];
            children.forEach(function (c) {
              var processedObj = {};
              processedObj.pawnId = c.pawn.pawnId;
              processedObj.name = (0, _get2["default"])(c, userList.childTextFieldPath).toString();
              processedObj.pawnHash = c.pawn.pawnHash;
              processedUserList.push(processedObj);
            });
            userListsObj[userList.handle] = processedUserList;
          });
          return _context10.a(2, userListsObj);
      }
    }, _callee10);
  }));
  return function buildUserLists(_x22, _x23, _x24, _x25) {
    return _ref10.apply(this, arguments);
  };
}();
var _fillActiveSession = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(_ref11) {
    var activeSession, queries, pawn, sessionData, flowProgressResponse, metricResponseItem;
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.n) {
        case 0:
          activeSession = _ref11.activeSession, queries = _ref11.queries, pawn = _ref11.pawn, sessionData = _ref11.sessionData;
          _context11.n = 1;
          return _getActiveSession(pawn, queries.getSession, activeSession.responseSet);
        case 1:
          flowProgressResponse = _context11.v;
          // map flowprogresslist to session activities
          if (flowProgressResponse.roles["".concat(pawn.role, "List")][0].flowProgressList.length > 0) {
            activeSession.activities.forEach(function (activity) {
              var activityProgress = (0, _find2["default"])(flowProgressResponse.roles["".concat(pawn.role, "List")][0].flowProgressList, function (fp) {
                return activity.flowHandle === fp.flowHandle;
              });
              var matchingAppdefActivity = (0, _find2["default"])(Appdefs.sessions.fixedSettings.activities, function (a) {
                return a.handle === activity.handle;
              });
              if (activityProgress) {
                // use matching progress from query
                activity.progress = (0, _omit2["default"])(activityProgress, ['flowHandle']);
              } else if ('acrossChildren' in activity && !('flowUserLists' in activity.acrossChildrenSettings)) {
                if (sessionData) {
                  var sessions = sessionData.sessions;
                  var sessionMatch = (0, _find2["default"])(sessions, function (s) {
                    return s.responseSet === activeSession.responseSet;
                  });
                  if (sessionMatch) {
                    var activityMatch = (0, _find2["default"])(sessionMatch.activities, function (a) {
                      return a.handle === activity.handle;
                    });
                    if (activityMatch.progress) {
                      activity.progress = activityMatch.progress;
                    } else {
                      activity.progress = {
                        started: false,
                        completed: false
                      };
                    }
                  } else {
                    activity.progress = {
                      started: false,
                      completed: false
                    };
                  }
                } else if ((0, _allChildrenComplete["default"])(activity, pawn.pawn, activeSession)) {
                  activity.progress = {
                    started: true,
                    completed: true
                  };
                } else {
                  activity.progress = {
                    started: false,
                    completed: false
                  };
                }
              } else {
                activity.progress = {
                  started: false,
                  completed: false
                };
              }
              if ('applicableMetricsHandle' in matchingAppdefActivity && 'source' in matchingAppdefActivity) {
                var applicableMetric = (0, _find2["default"])((0, _find2["default"])(Appdefs.metrics.sources, function (s) {
                  return matchingAppdefActivity.source === s.name;
                }).metrics, function (m) {
                  return m.name === matchingAppdefActivity.applicableMetricsHandle;
                });
                if (applicableMetric.defaultValue) {
                  activity.applicable = true;
                } else {
                  activity.applicable = false;
                }
              } else {
                activity.applicable = true;
              }
            });
          } else {
            activeSession.activities.forEach(function (a) {
              a.progress = {
                started: false,
                completed: false
              };
              var matchingAppdefActivity = (0, _find2["default"])(Appdefs.sessions.fixedSettings.activities, function (appdefActivity) {
                return a.handle === appdefActivity.handle;
              });
              if ('applicableMetricsHandle' in matchingAppdefActivity && 'source' in matchingAppdefActivity) {
                var applicableMetric = (0, _find2["default"])((0, _find2["default"])(Appdefs.metrics.sources, function (s) {
                  return matchingAppdefActivity.source === s.name;
                }).metrics, function (m) {
                  return m.name === matchingAppdefActivity.applicableMetricsHandle;
                });
                if (applicableMetric.defaultValue) {
                  a.applicable = true;
                } else {
                  a.applicable = false;
                }
              } else {
                a.applicable = true;
              }
            });
          }
          if (flowProgressResponse.roles["".concat(pawn.role, "List")][0].metricsList && flowProgressResponse.roles["".concat(pawn.role, "List")][0].metricsList.length > 0) {
            metricResponseItem = (0, _find2["default"])(flowProgressResponse.roles["".concat(pawn.role, "List")][0].metricsList, function (metric) {
              return metric.responseSet === activeSession.responseSet;
            });
            if (metricResponseItem && metricResponseItem.devTags) {
              activeSession.activities.forEach(function (activity) {
                var matchingAppdefActivity = (0, _find2["default"])(Appdefs.sessions.fixedSettings.activities, function (appdefActivity) {
                  return activity.handle === appdefActivity.handle;
                });
                if ('applicableMetricsHandle' in matchingAppdefActivity && 'source' in matchingAppdefActivity) {
                  var applicableMetric = (0, _find2["default"])((0, _find2["default"])(Appdefs.metrics.sources, function (s) {
                    return matchingAppdefActivity.source === s.name;
                  }).metrics, function (m) {
                    return m.name === matchingAppdefActivity.applicableMetricsHandle;
                  });
                  if (!(0, _isNull2["default"])(metricResponseItem.devTags[(0, _first2["default"])(applicableMetric.tags)])) {
                    activity.applicable = _findBoolean(metricResponseItem.devTags[(0, _first2["default"])(applicableMetric.tags)]);
                  }
                }
              });
            }
          }
          return _context11.a(2, activeSession);
      }
    }, _callee11);
  }));
  return function _fillActiveSession(_x26) {
    return _ref12.apply(this, arguments);
  };
}();
var _findBoolean = function _findBoolean(value) {
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  if (value === '1') {
    return true;
  }
  if (value === '0') {
    return false;
  }
  if (value) {
    return true;
  }
  if (!value) {
    return false;
  }
};

// Reducers
var _default = exports["default"] = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, SET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), UNSET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false
  });
}), SET_SESSION_DATA, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: action.payload
  });
}), UNSET_SESSION_DATA, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: []
  });
}), SET_ACTIVE_SESSION, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    activeSessionId: action.payload
  });
}), UNSET_ACTIVE_SESSION, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    activeSessionId: 0
  });
}), SET_CURRENT_ACTIVITY, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentActivityHandle: action.payload
  });
}), UNSET_CURRENT_ACTIVITY, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentActivityHandle: ''
  });
}), SET_ACTIVITY_APPLICABLE, function (state, action) {
  var newSessions = (0, _cloneDeep2["default"])(state.sessions);
  var activeSession = (0, _fixedSession.getActiveSession)(state);
  var existingActiveSession = (0, _find2["default"])(newSessions, function (ns) {
    return ns.responseSet === activeSession.responseSet;
  });
  var activity = (0, _find2["default"])(existingActiveSession.activities, function (a) {
    return a.handle === action.payload;
  });
  activity.applicable = true;
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: newSessions
  });
}), UNSET_ACTIVITY_APPLICABLE, function (state, action) {
  var newSessions = (0, _cloneDeep2["default"])(state.sessions);
  var activeSession = (0, _fixedSession.getActiveSession)(state);
  var existingActiveSession = (0, _find2["default"])(newSessions, function (ns) {
    return ns.responseSet === activeSession.responseSet;
  });
  var activity = (0, _find2["default"])(existingActiveSession.activities, function (a) {
    return a.handle === action.payload;
  });
  activity.applicable = false;
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: newSessions
  });
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, RESET_STATE, function (state, action) {
  return {
    loading: true,
    sessions: [],
    activeSessionId: 0,
    currentActivityHandle: ''
  };
}), SET_ACTIVITY_COMPLETE, function (state, action) {
  var newSessions = (0, _cloneDeep2["default"])(state.sessions);
  var activeSession = (0, _fixedSession.getActiveSession)(state);
  var existingActiveSession = (0, _find2["default"])(newSessions, function (ns) {
    return ns.responseSet === activeSession.responseSet;
  });
  var activity = (0, _find2["default"])(existingActiveSession.activities, function (a) {
    return a.handle === action.payload;
  });
  activity.progress.started = true;
  activity.progress.completed = true;
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: newSessions
  });
}), SET_SESSION_COMPLETE, function (state, action) {
  var newSessions = (0, _cloneDeep2["default"])(state.sessions);
  var session = (0, _find2["default"])(newSessions, function (a) {
    return a.handle === action.payload;
  });
  session.complete = true;
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: newSessions
  });
}), SET_SESSION_HELD_METRICS, function (state, action) {
  var newSessions = (0, _cloneDeep2["default"])(state.sessions);
  var session = (0, _find2["default"])(newSessions, function (s) {
    return s.responseSet === action.payload.responseSet;
  });
  session.held = action.payload.metrics.held;
  session.date = action.payload.metrics.date;
  session.complete = action.payload.metrics.complete;
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: newSessions
  });
}), SET_FILLED_SESSION, function (state, action) {
  var newSessions = (0, _cloneDeep2["default"])(state.sessions);
  var sessionIndex = (0, _findIndex2["default"])(newSessions, function (s) {
    return s.responseSet === action.payload.responseSet;
  });
  newSessions[sessionIndex] = action.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: newSessions
  });
}), SET_CURRENT_ACTIVITY_USER_LISTS, function (state, action) {
  var newSessions = (0, _cloneDeep2["default"])(state.sessions);
  var activeSession = (0, _fixedSession.getActiveSession)(state);
  var existingActiveSession = (0, _find2["default"])(newSessions, function (ns) {
    return ns.responseSet === activeSession.responseSet;
  });
  var activity = (0, _find2["default"])(existingActiveSession.activities, function (a) {
    return a.handle === state.currentActivityHandle;
  });
  activity.acrossChildrenSettings.formattedFlowUserLists = action.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    sessions: newSessions
  });
})), initialState);